import { Component, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Meta } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { DataService } from "src/app/services/data.service";
import { ElementRef, HostListener, ViewChild } from "@angular/core";
import { AuthService } from "src/app/services/auth.service";
import { buildSEOImageUrl } from "src/app/utils/seo-image.helper";

@Component({
  selector: "app-ai-images",
  templateUrl: "./ai-images.component.html",
  styleUrls: ["./ai-images.component.scss"],
})
export class AIImagesComponent implements OnInit {
  @ViewChild("autoSuggestion") autoSuggestion!: ElementRef;
@ViewChild('recentContainer') recentContainer!: ElementRef;
@ViewChild('popularContainer') popularContainer!: ElementRef;
  gap = 16;
  resizeObserver!: ResizeObserver;
  minItemWidth = 264; // controls how many columns per device
  activeTab: 'recent' | 'popular' = 'recent';
  slidesData: any = [];
  exclusiveData: any = [{}, {}, {}, {}];
  featuredData: any = [{}, {}, {}, {}];
  latestData: any = [{}, {}, {}, {}];
  popularData: any = [{}, {}, {}, {}];
  collectionData: any = [];
  othersData: any = [];

  illusData: any = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}];
  visibleIllusData: any[] = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}]
  pageSize = 20;
  currentPage = 1;
  isLoadingMore = false;

  illusPopularData: any = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}];
  visiblePopularData: any[] = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}];
  popularPageSize = 20;
  popularCurrentPage = 1;
  isPopularLoadingMore = false;
  constructor(
    private dataService: DataService,
    private meta: Meta,
    public router: Router,
    public authService: AuthService
  ) {
    // this.meta.addTag({ name: "description", content: "Collections" });
  }
  typeahead: FormControl = new FormControl();

  searchKey = "AI Images";

  suggestions: string[] = [];
  // loader = false;
  loader = false;
  imageLoad = true;
  user: any = {};
  previousUserId = "";

     getSEOImage(url: string): string {
    return buildSEOImageUrl(url);
  }

  async ngOnInit() {
    (await this.dataService.getCollectionBannerService()).subscribe(
      (singleservice) => {
        this.slidesData = [];
        this.slidesData = singleservice;
        //console.log(this.slidesData);
      }
    );
    if (sessionStorage.getItem("returnUrl")) {
      sessionStorage.removeItem("returnUrl");
    }
    this.user = this.dataService.userDetail;
    if (this.user && this.user.id) {
      this.authService.checkSubscriptionStatus(this.user, true);
      this.previousUserId = this.user.id;
      this.dataService.userDetails();
      // window.location.reload();
    }
    (await this.dataService.getHomeBannerService()).subscribe(
      (singleservice) => {
        this.slidesData = [];
        this.slidesData = singleservice;
      }
    );
    (await this.dataService.getAIIllustrationService()).subscribe(
      (singleservice) => {
        // console.log(singleservice);
        
        // this.illusData = [];
        this.illusData = singleservice || [];
        this.loader = false;
        this.imageLoad = false;
        this.initIllusLoad();   // ✅ after data assignment
      }
    );
    (await this.dataService.getAIIllustrationPopularService()).subscribe(
      (singleservice) => {
        // this.illusPopularData = [];
        this.illusPopularData = singleservice || [];
        this.loader = false;
        this.imageLoad = false;
        this.initPopularLoad(); // ✅ important
      }
    );
    (await this.dataService.getCollectionService()).subscribe(
      (singleservice) => {
        this.collectionData = [];
        this.collectionData = singleservice.filter(
          (c: any) => c.isAICollection
        );
        this.loader = false;
        this.imageLoad = false;
        //console.log(this.collectionData);
      }
    );
    (await this.dataService.getCollectionService()).subscribe(
      (singleservice) => {
        //console.log(singleservice);
        this.exclusiveData = [];
        this.featuredData = [];
        this.latestData = [];
        this.popularData = [];

        this.collectionData = [];
        this.collectionData = singleservice;
        // console.log(singleservice);
        for (let i = 0; i < singleservice.length; i++) {
          if (
            singleservice[i]["isExclusive"] &&
            this.exclusiveData.length < 5 &&
            singleservice[i]["isAICollection"]
          ) {
            this.exclusiveData.push(singleservice[i]);
          }
          if (
            singleservice[i]["isFeatured"] &&
            this.featuredData.length < 5 &&
            singleservice[i]["isAICollection"]
          ) {
            this.featuredData.push(singleservice[i]);
          }
          if (
            singleservice[i]["isLatest"] &&
            this.latestData.length < 5 &&
            singleservice[i]["isAICollection"]
          ) {
            this.latestData.push(singleservice[i]);
          }
          if (
            singleservice[i]["isPopular"] &&
            this.popularData.length < 5 &&
            singleservice[i]["isAICollection"]
          ) {
            this.popularData.push(singleservice[i]);
          }
          if (
            !singleservice[i]["isExclusive"] &&
            !singleservice[i]["isFeatured"] &&
            !singleservice[i]["isLatest"] &&
            !singleservice[i]["isPopular"] &&
            this.othersData.length < 5 &&
            singleservice[i]["isAICollection"]
          ) {
            this.othersData.push(singleservice[i]);
          }
        }
        // this.loader = false;
        //console.log(this.exclusiveData);
        //console.log(this.slidesData);
      }
    );
  }

  switchTab(tab: 'recent' | 'popular') {
  this.activeTab = tab;

  // 🔥 Freeze layout for one frame, then rebuild
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      this.scheduleMasonry();
    });
  });
}


  onRecentImageLoad(index: number, event: Event) {
  this.processImageLoad(this.illusData, index, event);
}

onPopularImageLoad(index: number, event: Event) {
  this.processImageLoad(this.illusPopularData, index, event);
}

private processImageLoad(list: any[], index: number, event: Event) {
  const img = event.target as HTMLImageElement;

  list[index].imageLoad = true;
  list[index].ratio = img.naturalHeight / img.naturalWidth;

  img.style.visibility = 'hidden';

  requestAnimationFrame(() => {
    img.classList.add('loaded');
    img.style.visibility = 'visible';
    this.scheduleMasonry();
  });
}


ngAfterViewInit() {
  this.scheduleMasonry();

  this.resizeObserver = new ResizeObserver(() => {
    this.scheduleMasonry();
  });

  this.resizeObserver.observe(this.recentContainer.nativeElement);
  this.resizeObserver.observe(this.popularContainer.nativeElement);
}

ngOnDestroy() {
  if (this.resizeObserver) {
    this.resizeObserver.disconnect();
  }
}


scheduleMasonry() {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {

      if (this.activeTab === 'recent') {
        this.buildMasonry(this.recentContainer.nativeElement, this.illusData);
      }

      if (this.activeTab === 'popular') {
        this.buildMasonry(this.popularContainer.nativeElement, this.illusPopularData);
      }

    });
  });
}



buildMasonry(container: HTMLElement, dataList: any[]) {
  const items = Array.from(container.querySelectorAll('.masonry-item')) as HTMLElement[];
  if (!items.length) return;

  const containerWidth = container.clientWidth - 32;

  let columnCount = Math.floor((containerWidth + this.gap) / (this.minItemWidth + this.gap));
  columnCount = Math.max(1, Math.min(columnCount, 5));
  if (columnCount < 1) columnCount = 1;
  // if (containerWidth < 480) columnCount = 2;

  const itemWidth = (containerWidth - (columnCount - 1) * this.gap) / columnCount;
  const colHeights = new Array(columnCount).fill(0);

  items.forEach((item, i) => {
    const data = dataList[i];
    item.style.width = `${itemWidth}px`;

    const height = data?.ratio ? itemWidth * data.ratio : itemWidth * 0.75;

    let col = colHeights.indexOf(Math.min(...colHeights));
    const x = col * (itemWidth + this.gap);
    const y = colHeights[col];

    item.style.transform = `translate(${x}px, ${y}px)`;
    colHeights[col] += height + this.gap;
  });

  container.style.height = Math.max(...colHeights) + 'px';
}

  suggest() {
    if (this.typeahead.value.length > 0) {
      this.searchKey == "Collections"
        ? (this.suggestions = this.collectionData
            .filter(
              (c) =>
                c.isAICollection &&
                c.collectionName
                  .toLowerCase()
                  .includes(this.typeahead.value.toLowerCase())
            )
            .slice(0, 5))
        : this.searchKey == "AI Images"
        ? (this.suggestions = this.illusData
            .filter(
              (c) =>
                c.isAIIllustration &&
                c.title
                  .toLowerCase()
                  .includes(this.typeahead.value.toLowerCase())
            )
            .slice(0, 5))
        : [];
    } else {
      this.suggestions = [];
    }
    //console.log(this.suggestions);
  }

  setSearchKey(data) {
    data == "collect"
      ? (this.searchKey = "Collections")
      : (this.searchKey = "AI Images");
  }

  getEncodedUrl(data) {
    return encodeURI(data);
  }

  navigateTo() {
    if (!this.typeahead.value || this.typeahead.value.trim() === "") {
      return;
    }

    this.router.navigate(["/search"], {
      queryParams: {
        value: this.typeahead.value,
        searchKey: "AI Images",
        searchType: this.searchKey,
      },
    });
    //console.log("enter pressed");
  }

  @HostListener("document:click", ["$event"])
  handleClickOutside(event: MouseEvent) {
    const clickedInside = this.autoSuggestion?.nativeElement.contains(
      event.target
    );
    if (!clickedInside) {
      this.suggestions = [];
      if (this.typeahead?.setValue) {
        this.typeahead.setValue("");
      }
    }
  }


    initIllusLoad() {
    this.currentPage = 1;
    this.visibleIllusData = this.illusData.slice(0, this.pageSize);
  }

  loadMoreIllus() {
    this.isLoadingMore = true;

    setTimeout(() => {
      this.currentPage++;

      this.visibleIllusData = this.illusData.slice(
        0,
        this.currentPage * this.pageSize
      );

      this.isLoadingMore = false;
    }, 300);
  }

  get hasMoreIllus(): boolean {
    return this.visibleIllusData.length < this.illusData.length;
  }

    /* ---------- Popular Grid ---------- */

    initPopularLoad() {
    this.popularCurrentPage = 1;
    this.visiblePopularData = this.illusPopularData.slice(
      0,
      this.popularPageSize
    );
  }

  loadMorePopular() {
    this.isPopularLoadingMore = true;

    setTimeout(() => {
      this.popularCurrentPage++;

      this.visiblePopularData = this.illusPopularData.slice(
        0,
        this.popularCurrentPage * this.popularPageSize
      );

      this.isPopularLoadingMore = false;
    }, 300);
  }

  get hasMorePopular(): boolean {
    return this.visiblePopularData.length < this.illusPopularData.length;
  }

}
